import { render, staticRenderFns } from "./runningAway.vue?vue&type=template&id=99e405a4&scoped=true"
import script from "./runningAway.vue?vue&type=script&lang=js"
export * from "./runningAway.vue?vue&type=script&lang=js"
import style0 from "./runningAway.vue?vue&type=style&index=0&id=99e405a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99e405a4",
  null
  
)

export default component.exports